import type { HotelOption, HotelRoom } from '../../types';
import { createWhitelabelUrl } from './kayakWhitelabel';

type Props = {
    destinationContext?: HotelOption;
    startDate?: Date;
    endDate?: Date;
    rooms: HotelRoom[];
};

export const HotelHiddenInputs = ({ destinationContext, startDate, endDate, rooms }: Props) => (
    <input
        data-testid="whiteLabelUrl"
        type="hidden"
        name="url"
        value={createWhitelabelUrl(destinationContext, startDate, endDate, rooms)}
    />
);
